import styled, { css } from 'styled-components';
import { baseTextStyle } from './style/base';
import { baseTypographyMixin } from './mixins/base';
import { baseLinkStyle } from './style/link';
import { baseLinkMixin } from './mixins/link';
import { activePressedStyle } from '../tokens/pressed';
import { sizes } from './constants/sizes';
import { lineHeight } from '../style/line-height';
import { fontSize } from '../style/font-size';
const Link = styled.a.attrs(({
  asSpan = false,
  asDiv = false,
  forwardedAs
}) => ({
  ...(asSpan ? {
    as: 'span'
  } : {}),
  ...(asDiv ? {
    as: 'div'
  } : {}),
  ...(forwardedAs ? {
    as: forwardedAs
  } : {})
}))`
  ${baseTextStyle}
  ${baseLinkStyle}
  ${baseTypographyMixin}
  ${baseLinkMixin}
  ${activePressedStyle}
  ${({
  block
}) => block ? `display: inline-block;` : ''}
  ${({
  flex
}) => flex ? `display: inline-flex;` : ''}
  ${({
  size
}) => size ? css`
          ${fontSize((sizes[size] || sizes.default).fontSize)}
          ${lineHeight((sizes[size] || sizes.default).lineHeight)}
        ` : ''}
`;
export default Link;